type CustomerType = {
    name: string;
    email: string;
};

type PaymentType = {
    transaction: string;
    method: string;
    status: string;
    amount: number;
    createdAt: string;
};

type ProductType = {
    name: string;
    description: string;
    image: string;
};

export default class GetSaleDTO {
    constructor(
        readonly id: string,
        readonly company: string,
        readonly customer: CustomerType,
        readonly page: string,
        readonly payment: PaymentType,
        readonly product: ProductType,
    ) {}
}